// import { HUD } from "../hud/HUD";
// import { BattleScene } from "../BattleScene";

// import { CoinsEffectPool } from "./CoinsEffectPool";

export class CoinsEffect extends Phaser.GameObjects.Image {

    public static coinsOnStage: number;

    // public n: number = 0;

    private f: number = 0;
    private end: { x: number, y: number }
    private start: { x: number, y: number }
    private spreadDistance: { min: number, max: number }

    constructor(scene: Phaser.Scene, frame: string, end: { x: number, y: number }, start: { x: number, y: number }, spreadDistance: { min: number, max: number }) {

        super(scene, start.x, start.y, "atlas", frame);

        this.visible = false;

        this.end = end;
        this.start = start;
        this.spreadDistance = spreadDistance;
    }

    public action() {
        const startX = this.start.x;
        const startY = this.start.y

        this.setVisible(true);
        this.setScale(1);
        this.alpha = 1;

        const angle = Phaser.Math.FloatBetween(-Math.PI / 2 -1.9, -Math.PI / 2 + 1.9)
        const distance = Phaser.Math.Between(-70, 70);
        const peakX = startX + Math.cos(angle) * distance;
        const peakY = startY + Math.sin(angle) * distance - Phaser.Math.Between(150, 250);

        const floorX = peakX + Phaser.Math.Between(-80, 80); 
        const floorY = startY + Phaser.Math.Between(260, 300) 

        this.scene.tweens.add({
            targets: this,
            x: peakX,
            y: peakY,
            duration: 400,
            ease: 'Sine.easeOut',
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this,
                    x: floorX,
                    y: floorY,
                    duration: 500,
                    ease: 'Bounce.easeOut',
                    onComplete: () => {
                        this.scene.time.delayedCall(1000 + Math.random() * 600, () => {
                            this.scene.tweens.add({
                                targets: this,
                                x: this.end.x,
                                y: this.end.y,
                                scale: 0.2,
                                alpha: 0,
                                duration: 500,
                                ease: 'Cubic.easeIn',
                                onComplete: () => {
                                    window.Telegram.WebApp.HapticFeedback.selectionChanged();
                                    this.reset();
                                }
                            });
                        });
                    }
                });
            }
        });
    }



    public reset(): void {
        this.visible = false;

        this.x = this.start.x + 20 - 50 * Math.random();;
        this.y = this.start.y + 20 - 80 * Math.random();

        this.alpha = 1;
    }
}
